// extracted by mini-css-extract-plugin
module.exports = {"main":"layout_main__boqbu","landing-sidebar":"layout_landing-sidebar__4_aZW","general-sidebar":"layout_general-sidebar__6lQsS","errorContent":"layout_errorContent__9bNbU"};